//HTTP status message
export const clientErrorMessage =
  "There seems to be an issue with the data you submitted. Please review and try again.";
export const serverErrorMessage =
  "We encountered an issue on our end while processing your request. Please try again later.";

//asset management
export const scope = [
  {
    name: "DECATHLON",
  },
  {
    name: "LANDLORD",
  },
];

export const assetTitle = "Assets";
export const assetCategoryTitle = "Asset Categories";
export const createAssetCategoryTitle = "Create Main Category";
export const editAssetCategoryTitle = "Edit Main Category";
export const createAssetSubCategoryTitle = "Create Sub Category";
export const editAssetSubCategoryTitle = "Edit Sub Category";

export const assetFileUploadModalTitle = "Bulk Asset Excel Upload";
export const assetFileUploadModalSubTitle = "Select & Upload Files of Asset List"
export const assetFileNotAttachedError = "Please attach a file before submitting"
export const assetStoreNotSelectedError = "Please select store before submitting"
export const fileUploadError = "Failed to upload the file"
export const fileUploadAttachFilesMessage = "Click here or Drag & Drop file to this area to upload"
export const assetFileUploadApi = "/api/uploadBulkAsset"
export const fileUploadSuccess = "file uploaded successfully."
export const fileUploadFailed = "file upload failed."


export const ContentModalProps = {
  error: {
    btnTitle: "Show Errors",
    btnColor: "red",
    modalTitle: "The following errors were found while validating the Excel file. Please correct and re-upload",
    modalClass: "error-modal",
    listClassName: "modal-error-list",
    modalWidth: 700,
  },
};

export const NotificationModules = {
  'Bulk-Upload': {
    Fail: {
      color: "rgb(255, 217, 213)",
      route: null,
    },
    Success: {
      color: "rgb(218, 239, 143)",
      route: '/Assets',
    },
    "In Progress": {
      color: "rgb(255 239 91)",
      route: null,
    },
  }
};
